// classificationOptions.js
// Static distribution and compartment option metadata used by classification menus

export const TOP_OPTION_LIMIT = 10;

export const DISTRIBUTION_OPTIONS = [
    {value: 'FOUO', label: 'FOUO - For Official Use Only'},
    {value: 'NOFORN', label: 'NOFORN - Not Releasable to Foreign Nationals'},
    {value: 'REL TO USA', label: 'REL TO USA - Releasable to USA'},
    {value: 'RELIDO', label: 'RELIDO - Releasable by Information Disclosure Official'},
    {value: 'ORCON', label: 'ORCON - Originator Controlled'},
    {value: 'PROPIN', label: 'PROPIN - Proprietary Information'},
    {value: 'LES', label: 'LES - Law Enforcement Sensitive'},
    {value: 'CNWDI', label: 'CNWDI - Critical Nuclear Weapon Design Information'},
    {value: 'NATO', label: 'NATO - North Atlantic Treaty Organization'},
    {value: 'DEA SENSITIVE', label: 'DEA SENSITIVE - Drug Enforcement Administration Sensitive'},
    {value: 'CRITICAL INFRA', label: 'CRITICAL INFRA - Critical Infrastructure Information'},
    {value: 'LAW ENF', label: 'LAW ENF - Law Enforcement Use Only'},
    {value: 'SAR', label: 'SAR - Special Access Required'},
    {value: 'FVEY', label: 'FVEY - Five Eyes'},
    {value: 'RSEN', label: 'RSEN - Risk Sensitive'},
];

export const COMPARTMENT_OPTIONS = [
    {value: 'SI', label: 'SI - Special Intelligence'},
    {value: 'TK', label: 'TK - Talent Keyhole'},
    {value: 'HCS', label: 'HCS - HUMINT Control System'},
    {value: 'GAMMA', label: 'GAMMA - Signals Intelligence Compartment'},
    {value: 'UMBRA', label: 'UMBRA - SIGINT Compartment'},
    {value: 'KLONDIKE', label: 'KLONDIKE - Sensitive Collection'},
    {value: 'MAJIC', label: 'MAJIC - Special Access Program'},
    {value: 'COBRA', label: 'COBRA - Controlled Access'},
    {value: 'RHYOLITE', label: 'RHYOLITE - Satellite SIGINT'},
    {value: 'FARMER', label: 'FARMER - Analysis Compartment'},
    {value: 'SPECTER', label: 'SPECTER - Counter Intelligence'},
    {value: 'CAVALIER', label: 'CAVALIER - Experimental Programs'},
    {value: 'OMEGA', label: 'OMEGA - Strategic Access'},
    {value: 'PHOENIX', label: 'PHOENIX - Operational Planning'},
    {value: 'BANSHEE', label: 'BANSHEE - Emergency Response'},
];

/**
 * Sort options alphabetically by value
 * @param {Array} options - Array of option objects with value and label properties
 * @returns {Array} Sorted array of options
 */
export const sortOptionsByValue = (options) =>
    [...options].sort((a, b) => a.value.localeCompare(b.value));

export const getDistributionOptions = () => sortOptionsByValue(DISTRIBUTION_OPTIONS);
export const getCompartmentOptions = () => sortOptionsByValue(COMPARTMENT_OPTIONS);
